// Generated from App.tsx for a single page build. Do not edit.
import { Routes, Route, useLocation } from 'react-router-dom';
import FrequentlyAskedQuestionsPage from "../pages/FrequentlyAskedQuestions/FrequentlyAskedQuestions";
const __wvcRoutePaths = ["/FrequentlyAskedQuestionsPage"];
function AppRoutes() {
  const location = useLocation();
  return <Routes key={location.pathname}>
            
            
            
            
            
            
            
            
            
            
            
            <Route path={__wvcRoutePaths[0]} element={<FrequentlyAskedQuestionsPage />} />
            
            </Routes>;
}
function App() {
  return <>
            <div className="app">
                <AppRoutes />
            </div>
        </>;
}
export default App;
